import useMediaQuery from "../../../common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "../../../utils/screenSizes";
import { type PdpPageProductData } from "~/ProductDetails/models/PdpPageProductData";

interface CalculationTabProps {
  product: PdpPageProductData;
}

export const ConfiguratorTab = (props: CalculationTabProps) => {
  const { product } = props;

  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  return (
    <div className={"scha__ignore-margins " + (isDesktop ? undefined : "w-100")}>
      <iframe
        className="scha__pdp-iframe"
        id="configuratorIframe"
        scrolling="yes"
        src={product.configuratorUrl}
      ></iframe>
    </div>
  );
};
